/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-distracting-elements */
import React from 'react'
import './m.css';
import './grey.css';
import ScrollAnimation from 'react-animate-on-scroll';
import b from '../Images/BLack.jpg';
import Glocal from "../Images/Glocal.png";
import FH from "../Images/FH.png";
export default function Marquee() {
    return (
        <>

            <div className="container-fluid min-vh-100 text-center m-0 d-flex flex-column justify-content-center">

            
                <div className="row justify-content-center no-gutters mb-5 mb-lg-0">
                    <div className="col-lg-6 col-md-6">
                        <ScrollAnimation animateIn='fadeIn'><img className="img-fluid vh-50" src={b} alt="UI" /></ScrollAnimation>
                    </div>
                    <div className="col-lg-6 vh-50 col-md-6">
                        <div className="text-center h-100 project">
                            <div className="d-flex h-100">
                                <div className="project-text w-100 my-auto text-center text-lg-left">
                                    <ScrollAnimation animateIn="zoomIn">
                                        <h4 className="imagee font-weight-bold">UI Designing</h4>
                                        <p className="imagee">ESPECERE , CODEY </p>
                                    </ScrollAnimation>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center no-gutters">
                    <div className="col-lg-6 vh-50 col-md-6">
                        <ScrollAnimation animateIn='fadeIn'>
                            <img className="img-fluid vh-50 " src={b} alt="AOP" />
                        </ScrollAnimation>
                    </div>
                    <div className="col-lg-6 col-md-6 order-lg-first">
                        <div className="ext-center h-100 project">
                            <div className="d-flex h-100">
                                <div className="project-text w-100 my-auto text-center text-lg-left">
                                    <ScrollAnimation animateIn="zoomIn">
                                        <h4 className="imagee font-weight-bold">APP DEVELOPEMENT</h4>
                                        <p className="imagee">Codey </p>
                                    </ScrollAnimation>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="row justify-content-center no-gutters mb-5 mb-lg-0">
                    <div className="col-lg-6 col-md-6 ">
                        <ScrollAnimation animateIn='fadeIn'><img className="img-fluid vh-50" src={Glocal} alt="UI" /></ScrollAnimation>
                    </div>
                    <div className="col-lg-6 vh-50 col-md-6">
                        <div className="text-center h-100 project">
                            <div className="d-flex h-100">
                                <div className="project-text w-100 my-auto text-center text-lg-left">
                                    <ScrollAnimation animateIn="zoomIn">
                                        <h4 className="imagee font-weight-bold">Web Designing</h4>
                                        <p className="imagee">Glocal Tech Seva </p>
                                    </ScrollAnimation>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="row justify-content-center no-gutters">
                <div className="col-lg-6 vh-50 col-md-6">
                    <ScrollAnimation animateIn='fadeIn'>
                        <img className="img-fluid vh-50 " src={FH} alt="AOP" />
                    </ScrollAnimation>
                </div>
                <div className="col-lg-6 col-md-6 order-lg-first">
                    <div className="ext-center h-100 project">
                        <div className="d-flex h-100">
                            <div className="project-text w-100 my-auto text-center text-lg-left">
                                <ScrollAnimation animateIn="zoomIn">
                                    <h4 className="imagee font-weight-bold">WEB DEVELOPEMENT</h4>
                                    <p className="imagee">Founder's Hope </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="row justify-content-center no-gutters mb-5 mb-lg-0">
            <div className="col-lg-6 col-md-6 ">
                <ScrollAnimation animateIn='fadeIn'><img className="img-fluid vh-50" src={b} alt="UI" /></ScrollAnimation>
            </div>
            <div className="col-lg-6 vh-50 col-md-6">
                <div className="text-center h-100 project">
                    <div className="d-flex h-100">
                        <div className="project-text w-100 my-auto text-center text-lg-left">
                            <ScrollAnimation animateIn="zoomIn">
                                <h4 className="imagee font-weight-bold">Desktop App </h4>
                                <p className="imagee">Deluxe AIO</p>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <div className="row justify-content-center no-gutters">
        <div className="col-lg-6 vh-50 col-md-6">
            <ScrollAnimation animateIn='fadeIn'>
                <img className="img-fluid vh-50 " src={b} alt="AOP" />
            </ScrollAnimation>
        </div>
        <div className="col-lg-6 col-md-6 order-lg-first">
            <div className="ext-center h-100 project">
                <div className="d-flex h-100">
                    <div className="project-text w-100 my-auto text-center text-lg-left">
                        <ScrollAnimation animateIn="zoomIn">
                            <h4 className="imagee font-weight-bold">Web Development</h4>
                            <p className="imagee">UpLaw </p>
                        </ScrollAnimation>
                    </div>
                </div>
            </div>
        </div>
    </div>




            </div>

        </>
    )
}
